import React from "react"
import { Typography } from "src/UILibrary"
import { useTranslation } from "react-i18next"
import { NEWS_INTERVIEW_TYPES_STRING } from "src/modules/const"

interface Props {
  category: string
}

export const NewsCategoryLabel = ({ category }: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: "mypage.news" })

  return (
    <>
      {category == NEWS_INTERVIEW_TYPES_STRING.NEWS ? (
        <Typography.InputFieldRequired
          sx={{
            p: "0px 10px",
            width: "fit-content",
            color: "#235496",
            borderWidth: "1px",
            borderStyle: "solid",
            borderRadius: "4px",
            borderColor: "#235496",
            fontSize: "13px",
          }}
        >
          {t("news")}
        </Typography.InputFieldRequired>
      ) : (
        <>
          {category == NEWS_INTERVIEW_TYPES_STRING.INTERVIEW ? (
            <Typography.InputFieldRequired
              sx={{
                p: "0px 10px",
                width: "fit-content",
                color: "#FB5607",
                borderWidth: "1px",
                borderStyle: "solid",
                borderRadius: "4px",
                borderColor: "#FB5607",
                fontSize: "13px",
              }}
            >
              {t("interview")}
            </Typography.InputFieldRequired>
          ) : (
            <Typography.InputFieldRequired
              sx={{
                p: "0px 10px",
                width: "fit-content",
                color: "#7DC522",
                borderWidth: "1px",
                borderStyle: "solid",
                borderRadius: "4px",
                borderColor: "#7DC522",
                fontSize: "13px",
              }}
            >
              {t("news")}
            </Typography.InputFieldRequired>
          )}
        </>
      )}
    </>
  )
}
